export default __webpack_public_path__ + "static/media/box-idle-1.329be3e6.png";